<template>
  <div class="header-page-information-bar">
    <div class="d-flex align-items-center ecl-container px-2">
      <img src="@/assets/eu-flag.png" class="eu-flag mr-2"/>
      <div class="mr-0 mr-sm-3 bright-text">An official website of the European Union</div>
      <div class="information-dropdown-container d-flex justify-content-end justify-content-sm-start">
        <a class="d-flex align-items-center how-do-you-know" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="bright-text mr-2 d-none d-sm-block">
            How do you know?
          </div>
          <font-awesome-icon :icon="['fas', 'chevron-down']" class="chevron-down"/>
        </a>
        <div class="dropdown-menu dropdown-menu-right dropdown-box" aria-labelledby="dropdownMenuLink">
          <p>All official European Union website addresses are in the europa.eu domain.</p>
          <a href="//europa.eu/european-union/contact/institutions-bodies_en" target="_blank">See all EU institutions and bodies</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'HeaderPageInformation',
  components: {
    FontAwesomeIcon,
  },
};

</script>

<style lang="scss" scoped>
  .container {
    height: 100%;
  }

  .row {
    height: 100%;
  }

  .header-page-information-bar {
    padding-left: 1%;
    background-color: #404040;
    height: 28px;
  }

  .eu-flag {
    width: 22px;
    height: 15px;
  }

  .bright-text {
    color: #EBEBEB;
    font-size: 14px;
  }

  .how-do-you-know {
    flex-shrink: 1;
    border: 3px solid transparent;
    outline: none !important;
    outline-offset: 0;

    &:hover {
      text-decoration: none;
      background-color: #fff;;
    }

    &[aria-expanded="true"]:focus {
      background-color: #fff;
      border: 3px solid #ffd617;
    }

    &[aria-expanded="true"]:focus div, &[aria-expanded="true"]:focus div + svg, &:hover div, &:hover div + svg {
      color: #0E47CB;
    }

    &[aria-expanded="true"] div + svg {
      transform: rotate(-180deg);
    }
  }

  .information-dropdown-container {
    flex-grow: 1;
    position: relative;
  }

  .chevron-down {
    color: #EBEBEB;
    font-size: 11px;
    transition: transform 0.3s;
  }

  .dropdown-box {
    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.4);
    font-size: 0.875rem;
    padding: 12px 16px;
    max-width: 455px;
    min-width: 335px;
  }
</style>
